import { type ReactElement } from 'react';

export const Placeholder = (): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 9V7H5V9H4ZM4 5V4H5V5H4ZM9 4H7V5H9V4ZM20 5V4H19V5H20ZM11 4V5H13V4H11ZM15 4V5H17V4H15ZM20 7H19V9H20V7ZM20 11H19V13H20V11ZM20 15H19V17H20V15ZM20 19H19V20H20V19ZM17 20V19H15V20H17ZM13 20V19H11V20H13ZM9 20V19H7V20H9ZM5 20V19H4V20H5ZM4 17H5V15H4V17ZM4 13H5V11H4V13Z"
        fill="#404040"
      />
    </svg>
  );
};
